var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":""}},[_c('img',{attrs:{"src":"/assets/app/img/logo.png","alt":"fusion-logo"}})]),_c('v-main',{staticClass:"main-login-layout"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }